import {APP} from 'constants/actions';
import {ActionType} from 'constants/flow/flowTypes';

import {PageAppType} from './pageAppType';

export const initialState = {
    page: '',
    event: '',
    params: {
        id: null,
        dyType: '',
        type: '',
    },
};

/**
 * App page data
 * @param {PageAppType} state - Current state
 * @param {ActionType<PageAppType>} action - Received action
 * @returns {PageAppType} current page data
 */
export default function pageApp(
    state: PageAppType = initialState,
    action: ActionType<PageAppType>,
): PageAppType {
    switch (action.type) {
        case APP.SAVE_LOCATION:
            return action.payload;
        default:
            return state;
    }
}
